import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import { useEffect } from 'react'
import { useTimer } from 'react-timer-hook'

dayjs.extend(duration)

export const useCountDown = (expiryTimestamp: Date) => {
  const { seconds, minutes, hours, days, restart } = useTimer({
    expiryTimestamp,
    onExpire: () => console.warn('onExpire called'),
  })

  const isLeftApplyDurationOneDays = days === 0
  const isLeftApplyDurationThreeDays = dayjs(expiryTimestamp).diff(dayjs(), 'd') < 3
  const isLeftApplyDurationSevenDays = dayjs(expiryTimestamp).diff(dayjs(), 'd') < 7
  const format = dayjs
    .duration({
      days,
      hours,
      minutes,
      seconds,
    })
    .format(isLeftApplyDurationOneDays ? 'H:m:ss' : 'D:H:m')
    .split(':')

  const timeUnit = isLeftApplyDurationOneDays ? ['시간', '분', '초'] : ['일', '시간', '분']

  const fullFormat = dayjs.duration({ days, hours, minutes, seconds }).format('D:H:m:ss').split(':')
  const fullTimeUnit = ['일', '시간', '분', '초']

  useEffect(() => {
    restart(expiryTimestamp)
  }, [expiryTimestamp])

  return {
    format,
    timeUnit,
    isLeftApplyDurationThreeDays,
    isLeftApplyDurationSevenDays,
    isLeftApplyDurationOneDays,
    fullFormat,
    fullTimeUnit,
  }
}
